module.exports = __webpack_public_path__ + "static/media/vinyl-sparkle.3cbaa091.webp";